/**
 * 랜딩페이지 탭 정의
 *
 * 시안 헤더(2828:1830)의 링크 3종을 그대로 쓴다. 동작은 기존 SplashPage의
 * 탭 전환 로직을 유지한다 — 라우팅을 건드리지 않아 FAQ 화면이 그대로 살아 있다.
 * (구 라벨 '인디피아 ?' → 시안대로 '문의'. 내용은 동일한 준비 중 화면.)
 */
export const LANDING_TABS = ['소개', 'FAQ', '문의'] as const;

export type LandingTab = (typeof LANDING_TABS)[number];
